import {Component, Input, OnInit} from '@angular/core';
import { CandidatStatusOnMission } from '../../../../../shared/utils/enums';
import {MissionService} from "../../../../../services/mission.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-candidature-status',
  templateUrl: './candidature-status.component.html',
  styleUrl: './candidature-status.component.scss'
})
export class  CandidatureStatusComponent implements OnInit {

  CandidatStatusOnMission =  CandidatStatusOnMission

  @Input() data: any;
  @Input() column: any; // Define input property for 'column'

  constructor(private missionService: MissionService, private router: Router) {
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  acceptCandidature() {
    const body = {
      candidatId: this.data.candidature.candidatId,
      missionId: this.data.id,
      status: CandidatStatusOnMission.ACCEPTED,
    }
    this.missionService.updateCandidateStatus(body).subscribe({
      next: () => {
        this.missionService.toggleRefreshMission()
      }
    })
  }
}
